import React from 'react'
import mobileApp from '../assets/images/mobile-app.png'
import mobileWeb from '../assets/images/mobile-web.png'
import website from '../assets/images/website.png'

const DevicesChart = ({ data }) => {
  let mobileAppCount = 0
  let mobileWebCount = 0
  let websiteCount = 0

  data.forEach((d) => {
    const device = d.Devices?.trim().toLowerCase()
    if (device === 'mobile app') {
      mobileAppCount++
    } else if (device === 'mobile web') {
      mobileWebCount++
    } else if (device === 'desktop') {
      websiteCount++
    }
  })

  const total = mobileAppCount + mobileWebCount + websiteCount
  const percent = (count) => (total ? ((count / total) * 100).toFixed(0) : 0)

  return (
    <div className="bg-white rounded shadow p-4 w-full">
      <h2 className="font-semibold text-sm text-gray-700 mb-4">DEVICES</h2>
      <div className="flex items-center justify-around space-x-4">
        {/* Mobile Web */}
        <DeviceItem
          image={mobileWeb}
          label="Mobile Web"
          percent={percent(mobileWebCount)}
          color="#38bdf8"
        />

        {/* Website */}
        <DeviceItem
          image={website}
          label="Website"
          percent={percent(websiteCount)}
          color="#f472b6"
        />

        {/* Mobile App */}
        <DeviceItem
          image={mobileApp}
          label="Mobile App"
          percent={percent(mobileAppCount)}
          color="#4ade80"
        />
      </div>
    </div>
  )
}

const DeviceItem = ({ image, label, percent, color }) => {
  return (
    <div className="flex flex-col items-center">
      <div className="relative w-24 h-24">
        <svg className="w-full h-full transform -rotate-90">
          <circle
            cx="48"
            cy="48"
            r="42"
            stroke="#e5e7eb"
            strokeWidth="12"
            fill="none"
          />
          <circle
            cx="48"
            cy="48"
            r="42"
            stroke={color}
            strokeWidth="12"
            fill="none"
            strokeDasharray={`${(percent * 264) / 100}, 264`}
          />
        </svg>
        <img
          src={image}
          alt={label}
          className="w-10 h-10 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
        />
      </div>
      <div className="mt-2 text-sm font-medium text-gray-700">{label}</div>
      <div className="text-lg font-bold">{percent}%</div>
    </div>
  )
}

export default DevicesChart
